import { errorsFactory } from '../../components/utils';

const BaseFileInfectedError = errorsFactory('NoProcessError');

class FileInfectedError extends BaseFileInfectedError {
    reason?: string;

    constructor(message?: string, reason?: string) {
        super(message);
        this.reason = reason;
    }
}

export default FileInfectedError;
